import { Directive, HostListener,HostBinding } from '@angular/core';

@Directive({ selector: '[ngChangeColorOnHover]' })
export class ChangeColorDirective {

    // HostBinding - conecta / associa as propriendades ou atributos dos elementos HTML com a directiva
    @HostBinding('style.backgroundColor') backgroundColor:string;

    constructor() { }

    /* HostListener - escuta e modifica o comportamento ou estado dos elementos HTML, 
     de acordo com o evento nativo da DOM.*/

    @HostListener('mouseenter') onMouseHover(){
        this.backgroundColor='#f4f4f4'
    }

    @HostListener('mouseleave') onMouseLeave(){
        this.backgroundColor='white'
    }

}